// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"c20ef44f","154":"40cb3131","159":"c2176b47","206":"fef31522","292":"eee7b6e0","412":"03e26ed9","696":"7444c912","761":"e5f55361","787":"4f57ac2b","804":"02579782","917":"7528d681","956":"024f772b"}[chunkId] + ".chunk.js";
};